/** @format */

import idx from 'idx';
import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { FollowLink } from '../FollowLink';
import { PAGES_PATH } from '../../../lib/variables';

const ApplicationSharingByLabel = ({ item }) => {
  // eslint-disable-next-line no-console
  console.log('ApplicationSharingByLabel', item);

  const { ApplicationId = '' } = item;

  return (
    <Table.Cell key={`row-${item.id}-label`} id={`row-${item.id}-label`}>
      <FollowLink
        to={`${PAGES_PATH}/application/${idx(item, _ => _.id)}`}
        message={`id: ${ApplicationId}`}
        copy={ApplicationId}
      >
        <strong>{idx(item, _ => _.label || 'no name')} </strong>
      </FollowLink>
    </Table.Cell>
  );
};

ApplicationSharingByLabel.propTypes = {
  item: PropTypes.object.isRequired,
};

export { ApplicationSharingByLabel };
